import React, { useState } from 'react';
import SessionDetails from 'components/InPersonTraining/shared/SessionDetails';
import Text, { TEXT_VARIANTS } from 'components/ui/Typography/Text';
import { Info, AlertTriangle } from 'react-feather';
import { BetaFeedback } from 'components/BetaProgram';
import EMAILS from 'constants/emails';

const SelectedEvent = ({ selectedEvent }) => {
  /*
  Fix snake_case issues. Once all of InPersonTraining/Training
  sends camelCase including in child components, then we can remove this.
  */
  selectedEvent.numberOfSessions = selectedEvent.numberOfSessions
    ? selectedEvent.numberOfSessions
    : selectedEvent.number_of_sessions;
  selectedEvent.isArchived = selectedEvent.isArchived
    ? selectedEvent.isArchived
    : selectedEvent.is_archived;
  selectedEvent.nextSession = selectedEvent.nextSession
    ? selectedEvent.nextSession
    : selectedEvent.next_session;
  selectedEvent.lastSession = selectedEvent.lastSession
    ? selectedEvent.lastSession
    : selectedEvent.last_session;

  const [showFullDesc, setShowFullDesc] = useState(false);
  const desc = selectedEvent.description;
  const truncatedDesc = `${desc.substring(0, 210)}...`;
  const isLongDescription = desc.length > 210;
  const hasMultipleSessions = selectedEvent.numberOfSessions > 1;
  const moreSessionsCount = selectedEvent.numberOfSessions - 1;

  return (
    <div className="EditorElement-body SelectedEvent d-f fd-c jc-c mt-12">
      {selectedEvent.isArchived && (
        <div className="alert alert-warning">
          <AlertTriangle size={18} className="mr-4" />
          <Text variant={TEXT_VARIANTS.BODY}>
            {t('lessons.editor.event.archived_event_message')}
          </Text>
          {/* This element does not live under a react router yet, so we have to use a normal anchor */}
          <a
            href={`/in_person_training/events/${selectedEvent.id}`}
            className="ml-4"
          >
            <Text variant={TEXT_VARIANTS.BODY_BOLD}>
              {t('lessons.editor.event.view_archived_event')}
            </Text>
          </a>
        </div>
      )}
      {!selectedEvent.nextSession && !selectedEvent.isArchived && (
        <div className="alert alert-info">
          <Info size={18} className="mr-4" />
          <Text variant={TEXT_VARIANTS.BODY}>
            {t('lessons.editor.event.past_event_message')}
          </Text>
        </div>
      )}
      <div
        className={`SelectedEvent--content d-f fd-c jc-c ${
          selectedEvent.isArchived ? 'SelectedEvent--disabled' : ''
        }`}
      >
        <div className="SelectedEvent--header d-f fd-c">
          <Text variant={TEXT_VARIANTS.SUBHEADER_BOLD}>
            {selectedEvent.name}
          </Text>
          {selectedEvent.description && (
            <Text
              variant={TEXT_VARIANTS.BODY_LIGHT}
              className="mb-8 description"
            >
              {!isLongDescription || showFullDesc ? desc : truncatedDesc}
              {isLongDescription && (
                <button
                  aria-label={showFullDesc ? 'see-less-btn' : 'see-more-btn'}
                  type="button"
                  className="u-resetBtn c-link as-fe ml-4"
                  onClick={() => setShowFullDesc(prev => !prev)}
                >
                  {showFullDesc
                    ? t('lessons.editor.event.see_less_button')
                    : t('lessons.editor.event.see_more_button')}
                </button>
              )}
            </Text>
          )}
        </div>
        {(selectedEvent.nextSession || selectedEvent.lastSession) && (
          <SessionDetails
            session={selectedEvent.nextSession || selectedEvent.lastSession}
            eventId={selectedEvent.id}
            showRegistrationCap
            hasMultipleSessions={hasMultipleSessions}
            moreSessionsCount={moreSessionsCount}
            previewing
            isArchived={selectedEvent.isArchived}
          />
        )}
      </div>
      <BetaFeedback
        recipient={EMAILS.EVENTS_FEEDBACK}
        betaFeatureName="Events in Lessons"
        className="mt-8"
      />
    </div>
  );
};

export default SelectedEvent;
